// Persistencia local de la última lista de "mis tareas" (GET /order/specialist/tareas)
// exitosa (offline, v1). Un solo registro en IndexedDB (localforage). Best-effort:
// si idb falla, degrada a no-op / null sin lanzar.
import localforage from 'localforage';

const store = localforage.createInstance({ name: 'prolift', storeName: 'offline-mis-tareas' });
const KEY = 'list';

export async function saveMisTareas(list) {
  if (!Array.isArray(list)) return;
  try {
    await store.setItem(KEY, { list, updatedAt: Date.now() });
  } catch {
    // best-effort
  }
}

export async function loadMisTareas() {
  try {
    const rec = await store.getItem(KEY);
    return rec?.list ?? null;
  } catch {
    return null;
  }
}

export async function clearMisTareas() {
  try {
    await store.removeItem(KEY);
  } catch {
    // best-effort
  }
}
